import { render } from "./adminDashboard.vue?vue&type=template&id=07bc9ea4"
import script from "./adminDashboard.vue?vue&type=script&lang=js"
export * from "./adminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__